export const formatInvoiceAmount = amount => {
	const parsedAmount = Number(amount)
	if (Number.isNaN(parsedAmount)) return '-'

	return parsedAmount.toLocaleString('es-AR', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})
}

export const getInvoiceSequence = invoice =>
	invoice?.nrsecuencia  ?? invoice?.nrSequencia ?? 0

export const parseInvoiceResults = (items = []) =>
	items.map((item, index) => {
		const invoiceSequence = getInvoiceSequence(item)
		return {
			...item,
			id: item.id || item.numeroComprobante || item.numeroFactura || index,
			factura: item.numeroFactura || '-',
			fecha: item.fecha || '-',
			importe: formatInvoiceAmount(item.importeComprobante),
			descargadaEstado: item.descargado ? 'Descargada' : 'No descargada',
			financiador: item.financiador || item.nombreFinanciador || item.obraSocial || '-',
			nrSequencia: invoiceSequence
		}
	})

export const mapInvoicesToRequest = invoices => ({
	Facturaciones: invoices.map(invoice => {
		return {
			centroFactura: invoice.centroFactura,
			numeroComprobante: invoice.numeroComprobante,
			tipoComprobante: invoice.tipoComprobante,
			tipoFactura: invoice.tipoFactura,			
		}
	})
})
